import type {
  AxiosResponse,
  AxiosError,
  InternalAxiosRequestConfig,
} from 'axios';
import type { InterceptorFactory } from './types';

/**
 * Body interceptor
 * - Forces `observe: 'body'` on request config when not present
 * - Rejects invalid HTML responses
 */
export const bodyInterceptor: InterceptorFactory = {
  request: () => ({
    onFulfilled: (
      config: InternalAxiosRequestConfig
    ): InternalAxiosRequestConfig => {
      if (config.observe === undefined) {
        return {
          ...config,
          observe: 'body',
        };
      }
      return config;
    },
    onRejected: (error: AxiosError): Promise<never> =>
      Promise.reject(error),
  }),

  response: () => ({
    onFulfilled: (response: AxiosResponse): AxiosResponse => {
      // Reject invalid HTML responses
      if (response.headers['content-type'] === 'text/html') {
        throw response;
      }
      return response;
    },
    onRejected: (error: AxiosError): Promise<never> =>
      Promise.reject(error),
  }),
};